// src/services/forgot.js
import { api, extractJsonObject } from "./api";

function toJson(respData) {
  if (typeof respData === "object") return respData;
  const cleaned = extractJsonObject(respData);
  return JSON.parse(cleaned);
}

export async function requestForgotOtpApi(mobno) {
  const body = new URLSearchParams();
  body.append("mobno", String(mobno).replace(/\D+/g, ""));

  const resp = await api.post("forgot_send_otp.php", body.toString(), {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });

  return toJson(resp.data); // expected: {ok:true,...} or {ok:false,error:""}
}

export async function resetPasswordWithOtpApi(mobno, otp, newPass) {
  const body = new URLSearchParams();
  body.append("mobno", String(mobno).replace(/\D+/g, ""));
  body.append("otp", String(otp).trim());
  body.append("newpass", String(newPass));

  const resp = await api.post("forgot_reset_password.php", body.toString(), {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });

  return toJson(resp.data); // expected: {ok:true} or {ok:false,error:""}
}
